// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAB2cPoq9rfbGY4GDVWgjY9ZxUVuGmpNl8",
    authDomain: "yebo-eggs.firebaseapp.com",
    projectId: "yebo-eggs",
    storageBucket: "yebo-eggs.firebasestorage.app",
    messagingSenderId: "827095575316",
    appId: "1:827095575316:web:b1ddcbbb1b828e9d9a3001",
    measurementId: "G-SS1VGFHF0J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export const requestToken = async () => {
    try {
        if (!import.meta.env.VITE_APP_FIREBASE_KEY) {
            console.error("FCM Flow: VITE_APP_FIREBASE_KEY is missing!");
            return;
        }

        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
            console.log("FCM Flow: Notification permission not granted.");
            return;
        }

        const registration = await navigator.serviceWorker.ready;

        const token = await getToken(messaging, {
            vapidKey: import.meta.env.VITE_APP_FIREBASE_KEY,
            serviceWorkerRegistration: registration,
        });
        console.log("FCM Flow: Token received:", token);

        if (token) {
            localStorage.setItem(`${import.meta.env.VITE_BUSINESS}fcmToken`, token);
            console.log("FCM Flow: Token received:", token);
        } else {
            console.log("FCM Flow: No registration token available.");
        }
    } catch (error) {
        console.error("FCM Flow: Error getting token:", error);
    }
}

export { app, analytics, messaging };
